const QUERY_PARAM_VALUES = {
    CONNECTION_TYPE_WIFI: 'w',
    CONNECTION_TYPE_CELLULAR: 'c',
    CONNECTION_TYPE_SIDEWALK: 's',
    DEVICE_TYPE_ILUMA_I2: 'm',
    DEVICE_TYPE_ILUMA_I5: 'o',
    QR_TYPE_PACKAGING: 'p',
    QR_TYPE_QSG: 'q',
    QR_TYPE_DEVICE_UI: 'd',
    SOURCE_TYPE_QR: 'qr',
    EVENT_TYPE_PUSH_NOTIFICATION_CLICK: 'push_notification_click',
};

export default QUERY_PARAM_VALUES;
